import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from '../reducers/index'
import { initializers } from '../actions/themeActions'
/* Middlewares */
import initializeCurrentUserMiddleware from '../middlewares/initialize_current_user'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const middlewares = [initializeCurrentUserMiddleware, thunkMiddleware]

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewares)))

process.env.NODE_ENV !== 'test' && initializers.actions.forEach(action => store.dispatch(action))

export default store
